import { t } from '@lingui/core/macro';
import { Alert, Box } from '@pocketlaw/tetris';
import { PageLoader } from 'shared/domains/common-ui';
import { SearchResultsListItem } from '../SearchResultsListItem';
import { SearchResultsNoMatch } from '../SearchResultsNoMatch';
import { SearchResultsPagination } from '../SearchResultsPagination';
export function SearchResultsList(props) {
    const { filters, results = [], loading, error, resultsLimit = 0, totalResultsCount = 0 } = props;
    if (loading) {
        return <PageLoader />;
    }
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>);
    }
    return (<Box flexDirection="column" gap="md">
      {filters}
      <SearchResultsPagination disabled={loading} limit={resultsLimit} totalCount={totalResultsCount}/>
      {results.length > 0 ? (<ul>
          {results.map((result) => (<SearchResultsListItem key={result.id} result={result}/>))}
        </ul>) : (<SearchResultsNoMatch />)}
    </Box>);
}
